export const ALPHABETICAL = 'alphabetical';
export const CHRONOLOGICAL = 'chronological';
export const LATEST_FIRST = 'latest-first';
export const REVERSE_CHRONOLOGICAL = 'reverse-chronological';



/** WEBPACK FOOTER **
 ** ./src/show-page/constants/season-order.js
 **/